<template>
  <div>
    <!-- <el-button type="success" v-print="'#pdfDom'"><i class="el-icon-printer"></i>打印</el-button> -->
    <!-- <el-button type="success" @click="handlePrint"><i class="el-icon-printer" style="font-size: 18px;"></i>打印</el-button> -->
    <!-- <el-button type="success" @click="getPdf">下载pdf</el-button> -->
    <div id="pdfDom">
      <table border="0" width="70%">
        <thead>
          <tr>
            <th colspan="7" style="text-align: center;">客户线上反馈表</th>
          </tr>
          <tr>
            <th colspan="7" class="cont">尊敬的客户：</th>
          </tr>
          <tr>
            <th colspan="7" class="cont">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您好！园测信息科技股份有限公司决定开展项目满意度测评，请您根据实际情况及业务接触中的亲身感受进行评价。您的反馈将为我司后期有针对性地提升服务水平与服务质量带来巨大的帮助，非常感谢您的配合！
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2" class="TDtitle">项目名称</td>
            <td colspan="5">{{ enterData.projectName }}</td>
          </tr>
          <tr>
            <td colspan="2" class="TDtitle">项目经理</td>
            <td colspan="5">{{ enterData.projectManager }}</td>
          </tr>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">服务态度</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyService">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyServiceDesc }}</td>
            </tr>
          </template>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">响应度</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyResponsivity">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyResponsivityDesc }}</td>
            </tr>
          </template>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">沟通能力</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyCommunication">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyCommunicationDesc }}</td>
            </tr>
          </template>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">工作规范度及技能专业性</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyProfession">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyProfessionDesc }}</td>
            </tr>
          </template>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">时效性</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyTimeliness">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyTimelinessDesc }}</td>
            </tr>
          </template>
          <template>
            <tr>
              <td rowspan="3" colspan="1" class="TDtitle">首期服务成果</td>
              <td colspan="1">选项</td>
              <td colspan="1" v-for="item in pointArr" :key="item">{{ item }}</td>
            </tr>
            <tr>
              <td colspan="1">评价</td>
              <td colspan="1" v-for="item in poingArr" :key="item">
                <i v-if="item == enterData.surveyService1">✔</i>
              </td>
            </tr>
            <tr>
              <td colspan="1">具体意见</td>
              <td colspan="5">{{ enterData.surveyService1Desc }}</td>
            </tr>
          </template>
          <tr>
            <td class="textArea" colspan="7">
              <span class="TDtitle">您是否愿意继续选择或推荐园测信科？</span><br>
              <span class="choose" v-for="item in pointArr2" :key="item.label">
                <i v-if="item.value == enterData.surveySrecommend" class="checkIcon">✔</i>
                □ {{ item.label }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="textArea" colspan="7">
              <span class="TDtitle">您对园测信科是否有其他建议？</span><br>
              <span>{{ enterData.surveyOther }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="TDtitle red">整体满意度（≤100）</td>
            <td colspan="1">{{ enterData.customerSatisfaction }}</td>
            <td colspan="2" class="TDtitle red">客户签字</td>
            <td colspan="2">{{ enterData.customerName }}</td>
          </tr>
          <tr>
            <td colspan="2" class="TDtitle red">联系方式</td>
            <td colspan="1">{{ enterData.customerPhone }}</td>
            <td colspan="2" class="TDtitle">签收日期</td>
            <td colspan="2">{{ enterData.createTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Print from 'print-js'
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: "satisfaction",
  props: ['enterData'],
  data() {
    return {
      pointArr: ['非常满意', '满意', '一般', '不满意', '非常不满意'],
      pointArr2: [{
        label: '非常愿意',
        value: '100'
      }, {
        label: '愿意',
        value: '80'
      }, {
        label: '一般',
        value: '60'
      }, {
        label: '不愿意',
        value: '40'
      }, {
        label: '非常不愿意',
        value: '20'
      }],
      itemArr: ['服务态度', '响应度', '沟通能力', '工作规范度及技能专业性', '时效性', '首期服务成果'],
      poingArr: ['100', '80', '60', '40', '20']
    }
  },
  mounted() {
  },
  methods: {
    handlePrint() {
      printJS({
        printable: 'pdfDom', // 表格的id
        type: 'html', // 打印类型为HTML
        style: 'table { width: 100%; }', // 可选的样式
        // 继承原来的所有样式
        targetStyles: ['*'],
      });
    },
    getPdf() {
      let title = '客户线上反馈表' //
      html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        // y: 72, // 对Y轴进行裁切
        // width:1200,
        // height:5000,
        dpi: window.devicePixelRatio * 4, //将分辨率提高到特定的DPI 提高四倍
        scale: 4 //按比例增加分辨率 
      }).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    }
  },
};
</script>

<style lang="scss">
#pdfDom {
  display: flex;
  justify-content: center;

  table {
    border-collapse: collapse;

    thead th {
      font-size: 20px;
      padding: 10px;
    }

    tbody {
      tr {
        height: 45px;
        font-size: 14px;
      }

      td {
        // width: 25%;
        text-align: center;
        width: 15%;
        border: 2px solid black;
      }

      .textArea {
        // height: 200px;
        padding: 15px 10px 15px;
        text-align: left;
        vertical-align: top;

        .choose {
          padding-right: 50px;
          line-height: 70px;
          position: relative;

          .checkIcon {
            position: absolute;
            // bottom: 0;
            bottom: -25px;
          }
        }
      }
    }
  }
}

.TDtitle {
  font-weight: 900;
  text-align: center;
}

.red {
  color: red;
}

.cont {
  // width: 70vw;
  font-weight: normal;
  line-height: 50px;
  text-align: left;
  font-size: 18px !important;
  padding: 0 !important;
}

i {
  font-size: 25px;
}
</style>